import type { FilterBlockItemConfig, FilterBlockValue } from '@lighthouse/core'
import { FilterBlockMode } from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

import type { FilterItemProps } from '../types'
import { NormalFilterItem } from './NormalFilterItem'
import { TileFilterItem } from './TileFilterItem'

const SCxNormalFilterList = styled.div`
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    /* gap: 8px; */
    row-gap: 4px;
    max-width: 100%;
    /* overflow: hidden; */
`

interface DesktopFilterProps
    extends Pick<
        FilterItemProps,
        | 'labelWidth'
        | 'showLabel'
        | 'noFilterLabel'
        | 'dataSourceList'
        | 'onChange'
        | 'onFetchTextOptions'
        | 'onFetchCascadeOptions'
        | 'labelColor'
        | 'isWrap'
        | 'useParseVariableWithSubscription'
    > {
    list: FilterBlockItemConfig[]
    mode: FilterBlockMode
    filterData: FilterBlockValue
}

export const DesktopFilter: React.FC<DesktopFilterProps> = ({ list, mode, showLabel, labelWidth, filterData, isWrap, ...rest }) => {
    return (
        <>
            {mode === FilterBlockMode.normal ? (
                <SCxNormalFilterList>
                    {list.map(item => (
                        <NormalFilterItem
                            key={item.id}
                            config={item}
                            value={filterData?.[item.id]?.value}
                            customValue={filterData?.[item.id]?.customValue}
                            {...rest}
                        />
                    ))}
                </SCxNormalFilterList>
            ) : (
                list.map(item => (
                    <TileFilterItem
                        key={item.id}
                        config={item}
                        isWrap={isWrap}
                        showLabel={showLabel}
                        labelWidth={labelWidth}
                        value={filterData?.[item.id]?.value}
                        customValue={filterData?.[item.id]?.customValue}
                        {...rest}
                    />
                ))
            )}
        </>
    )
}
